import React, { useContext, useMemo } from 'react'

import TableContent from '../../../elem/table/ssr/TableContent'
import { ParameterContext } from '../../../wrappers/ParameterContext'
import { DataContext } from './DataContext'
import parseColumns from '../../../../utils/table/parseColumns'
import NoDataComponent from '../../../elem/table/ssr/NoDataComponent'
import withConfig from '../../../wrappers/withConfig'

const List = ({ filterExpanded, toggleFilter, config }) => {
    const dataContext = useContext(DataContext)
    const { params, setParams, storedParams, refinedParams } = useContext(
        ParameterContext
    )
    const { data, loading, meta, filterFields } = dataContext
    const { EXPLORER_LINK_COLUMN, ID_COLUMN } = config
    const { pageCount, count, pageSize } = meta

    const adjustedPageCount =
        (count / pageSize) % 1 === 0 ? pageCount - 1 : pageCount

    const columns = useMemo(() =>
        parseColumns(data, filterFields, EXPLORER_LINK_COLUMN, ID_COLUMN)
    )

    if (count === 0) {
        return (
            <NoDataComponent
                filterExpanded={filterExpanded}
                toggleFilter={toggleFilter}
            />
        )
    }

    return (
        <TableContent
            name="sample"
            columns={columns}
            data={data}
            loading={loading}
            pageCount={adjustedPageCount}
            resultsCount={count}
            params={params}
            setParams={setParams}
            storedParams={storedParams}
            refinedParams={refinedParams}
            filterFields={filterFields}
            filterExpanded={filterExpanded}
        />
    )
}

export default withConfig(List)
